(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solvair-check-in"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('solvair-check-in')) {
    customElements.define('solvair-check-in', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const form = this.querySelector('[data-quiz-form]');
        const results = this.querySelector('[data-quiz-result]');
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          if (!form.reportValidity()) return;
          const answers = Object.fromEntries(new FormData(form));
          const key = this.recommend(answers);
          results.querySelectorAll('[data-result]').forEach((result) => {
            result.hidden = result.dataset.result !== key;
          });
          results.querySelectorAll('[data-context]').forEach((note) => {
            note.hidden = note.dataset.context !== answers.context;
          });
          form.hidden = true;
          results.hidden = false;
          results.querySelector(`[data-result="${key}"] h2`).focus();
        }, options);
        this.querySelector('[data-quiz-reset]').addEventListener('click', () => {
          form.reset();
          results.hidden = true;
          form.hidden = false;
          form.querySelector('input').focus();
        }, options);
        this.querySelector('[data-quiz-fallback]').hidden = true;
        form.hidden = false;
      }

      recommend(answers) {
        if (answers.feeling === 'reactive' || answers.concern === 'sensitivity') return 'sensitive';
        if (answers.concern === 'breakouts' && answers.area === 'face_body') return 'body';
        if (answers.concern === 'marks') return 'marks';
        if (answers.concern === 'breakouts') return 'breakout';
        if (['oily_tight', 'dry'].includes(answers.feeling) || answers.concern === 'tightness') return 'hydration';
        if (answers.routine === 'minimal') return 'simple';
        return 'full';
      }

      disconnectedCallback() {
        this.controller.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solvair-contact"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('solvair-contact')) {
    customElements.define('solvair-contact', class extends HTMLElement {
      connectedCallback() {
        const select = this.querySelector('[data-restock-product]');
        const product = new URLSearchParams(window.location.search).get('product');
        if (select && [...select.options].some((option) => option.value === product)) {
          select.value = product;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solvair-footer"]) return;
  try {
    
  if (!customElements.get('solvair-footer')) {
    customElements.define('solvair-footer', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.groups = Array.from(this.querySelectorAll('[data-footer-group]'));
        this.desktop = matchMedia('(min-width: 990px)');
        const options = { signal: this.controller.signal };
        this.desktop.addEventListener('change', () => this.updateLayout(), options);
        this.addEventListener('click', (event) => {
          if (!this.desktop.matches) return;
          const summary = event.target.closest('summary');
          if (summary?.parentElement?.hasAttribute('data-footer-group')) event.preventDefault();
        }, options);
        this.updateLayout();
      }

      updateLayout() {
        this.groups.forEach((group) => {
          const summary = group.querySelector('summary');
          const focusInside = group.contains(document.activeElement);
          group.open = this.desktop.matches;
          summary.tabIndex = this.desktop.matches ? -1 : 0;
          if (!this.desktop.matches && focusInside) summary.focus();
        });
      }

      disconnectedCallback() {
        this.controller.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solvair-header"]) return;
  try {
    
  if (!customElements.get('solvair-header')) {
    customElements.define('solvair-header', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.setHeaderHeight();
        this.resizeObserver = new ResizeObserver(() => this.setHeaderHeight());
        this.resizeObserver.observe(this);
        const options = { signal: this.controller.signal };
        this.addEventListener('toggle', (event) => {
          const detail = event.target;
          if (detail.tagName !== 'DETAILS' || !detail.open) return;
          for (const sibling of detail.parentElement.children) {
            if (sibling !== detail && sibling.tagName === 'DETAILS') sibling.open = false;
          }
        }, { ...options, capture: true });
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          const openDetail = event.target.closest('details[open]');
          if (!openDetail) return;
          openDetail.open = false;
          openDetail.querySelector('summary').focus();
          event.stopPropagation();
        }, options);
        document.addEventListener('click', (event) => {
          if (!this.contains(event.target)) this.closeMenus();
        }, options);
        this.addEventListener('focusout', (event) => {
          // activeElement can still be body while focus moves between menu items.
          if (!(event.relatedTarget instanceof Node) || !this.contains(event.relatedTarget)) this.closeMenus();
        }, options);
        matchMedia('(min-width: 990px)').addEventListener('change', () => this.closeMenus(), options);
      }

      closeMenus() {
        this.querySelectorAll('details[open]').forEach((detail) => { detail.open = false; });
      }

      setHeaderHeight() {
        document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
      }

      disconnectedCallback() {
        this.controller.abort();
        this.resizeObserver.disconnect();
        document.documentElement.style.removeProperty('--header-height');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solvair-principles"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('solvair-principles')) {
    customElements.define('solvair-principles', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-principle-panel]'));
        if (this.slides.length < 2) return;
        this.delay = Number(this.dataset.interval) * 1000;
        if (!Number.isFinite(this.delay) || this.delay < 5000) {
          console.error('Solvair principles: invalid rotation interval.');
          return;
        }
        this.controller = new AbortController();
        this.controls = this.querySelector('.sv-principles__controls');
        this.button = this.querySelector('.sv-principles__rotation');
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = this.querySelector('.sv-principles__panels');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.autoplay = this.dataset.autoplay === 'true' && !window.Shopify?.designMode;
        this.visible = false;
        this.hovering = false;
        this.paused = false;
        this.timer = null;
        const options = { signal: this.controller.signal };
        this.button.addEventListener('click', () => {
          this.paused = !this.paused;
          this.updateRotation();
        }, options);
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index, true), options);
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index), options);
          this.slides[index].setAttribute('role', 'tabpanel');
          this.slides[index].setAttribute('aria-labelledby', tab.id);
          this.slides[index].querySelector('.sv-principles__heading').classList.add('visually-hidden');
        });
        this.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'touch') return;
          this.hovering = true;
          this.updateRotation();
        }, options);
        this.addEventListener('pointerleave', () => {
          this.hovering = false;
          this.updateRotation();
        }, options);
        this.addEventListener('focusin', (event) => {
          if (this.button.contains(event.target)) return;
          this.paused = true;
          this.updateRotation();
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.select(index, true);
        }, options);
        this.motion.addEventListener('change', () => this.updateRotation(), options);
        document.addEventListener('visibilitychange', () => this.updateRotation(), options);
        this.intersections = new IntersectionObserver((entries) => {
          this.visible = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.2);
          this.updateRotation();
        }, { threshold: [0, 0.2] });
        this.resizeObserver = new ResizeObserver(() => this.updateControlsHeight());
        this.controls.hidden = false;
        this.toggleAttribute('data-enhanced', true);
        this.select(0);
        this.updateControlsHeight();
        this.intersections.observe(this);
        this.resizeObserver.observe(this.controls);
      }

      select(index, manual = false) {
        this.activeIndex = index;
        if (manual) this.paused = true;
        this.slides.forEach((slide, slideIndex) => {
          const selected = slideIndex === index;
          slide.inert = !selected;
          slide.setAttribute('aria-hidden', String(!selected));
          this.tabs[slideIndex].setAttribute('aria-selected', String(selected));
          this.tabs[slideIndex].tabIndex = selected ? 0 : -1;
        });
        this.updateRotation();
      }

      onKeydown(event, index) {
        const destination = {
          ArrowDown: index + 1,
          ArrowRight: index + 1,
          ArrowUp: index - 1,
          ArrowLeft: index - 1,
          Home: 0,
          End: this.slides.length - 1,
        }[event.key];
        if (destination === undefined) return;
        event.preventDefault();
        const next = (destination + this.slides.length) % this.slides.length;
        this.select(next, true);
        this.tabs[next].focus();
      }

      updateControlsHeight() {
        this.style.setProperty('--sv-principles-controls-height', `${Math.ceil(this.controls.getBoundingClientRect().height)}px`);
      }

      updateRotation() {
        clearTimeout(this.timer);
        this.timer = null;
        const allowed = this.autoplay && !this.motion.matches;
        this.button.hidden = !allowed;
        this.toggleAttribute('data-paused', this.paused);
        this.button.setAttribute('aria-pressed', String(this.paused));
        this.button.setAttribute('aria-label', this.paused ? this.button.dataset.resumeLabel : this.button.dataset.pauseLabel);
        const playing = allowed && !this.paused && !this.hovering && this.visible && !document.hidden;
        this.toggleAttribute('data-playing', playing);
        this.panels.setAttribute('aria-live', playing ? 'off' : 'polite');
        if (playing) this.timer = setTimeout(() => this.select((this.activeIndex + 1) % this.slides.length), this.delay);
      }

      disconnectedCallback() {
        this.controller?.abort();
        clearTimeout(this.timer);
        this.intersections?.disconnect();
        this.resizeObserver?.disconnect();
        this.removeAttribute('data-enhanced');
        this.removeAttribute('data-playing');
        this.style.removeProperty('--sv-principles-controls-height');
        if (this.controls) this.controls.hidden = true;
        this.slides.forEach((slide) => {
          slide.inert = false;
          slide.removeAttribute('aria-hidden');
          slide.removeAttribute('aria-labelledby');
          slide.removeAttribute('role');
          slide.querySelector('.sv-principles__heading').classList.remove('visually-hidden');
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solvair-reels"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('solvair-reels')) {
    customElements.define('solvair-reels', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.videos = Array.from(this.querySelectorAll('video'));
        const options = { signal: this.controller.signal };
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.intersectionRatio < 0.25) entry.target.pause();
          });
        }, { threshold: 0.25 });
        this.videos.forEach((video) => {
          video.addEventListener('play', () => {
            document.querySelectorAll('solvair-reels video').forEach((other) => {
              if (other !== video) other.pause();
            });
          }, options);
          const error = video.closest('.sv-reels__card').querySelector('.sv-reels__error');
          const failedSources = new Set();
          video.addEventListener('loadstart', () => failedSources.clear(), options);
          // Source errors from video_tag do not bubble to the video.
          video.addEventListener('error', (event) => {
            if (event.target === video) {
              error.hidden = false;
            } else if (event.target.tagName === 'SOURCE') {
              failedSources.add(event.target);
              const sources = Array.from(video.querySelectorAll('source')).filter((source) => (
                !source.type || video.canPlayType(source.type)
              ));
              if (sources.every((source) => failedSources.has(source))) error.hidden = false;
            }
          }, { ...options, capture: true });
          video.addEventListener('loadeddata', () => { error.hidden = true; }, options);
          this.observer.observe(video);
        });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.videos.forEach((video) => video.pause());
        }, options);
      }

      disconnectedCallback() {
        this.controller.abort();
        this.observer.disconnect();
        this.videos.forEach((video) => video.pause());
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
